<span class="custom-cell-icon-content">
    @if (icon()) {
        <span class="custom-cell-icon" [innerHTML]="icon()"></span>
    }
    @if (content()) {
        <span class="custom-cell-content" [innerHTML]="content()"></span>
    }
</span>
